module.exports = __webpack_public_path__ + "static/img/singapore.c8e0942b.jpg";